<template>
  <v-container fill-height="fill-height" style="opacity: .91">
        <v-layout align-center="align-center" justify-center="justify-center">
                <v-fade-transition mode="out-in">

          <v-flex class="login-form text-xs-center"> 
            <div class="display-1 mb-3 black--text">
              <v-row dense>
                    <v-col cols="2">
                        <img style="max-width: 100%; height: auto" src="../assets/logoorange.png" />
                    </v-col>
                    <v-col cols="10" style="align-self: center">
                        <img style="max-width: 100%; height: auto" src="../assets/snatch_word_yellow.png" />
                    </v-col>
                </v-row>Welcome to Snatch
            </div>
            <v-card light="light">
              <v-card-text>
                <div class="subheading">
                  <template>Register your email address</template>
                </div>
                <v-form ref="loginForm" action="#" @submit.prevent="validateBeforeSubmit" lazy-validation>
                  <v-text-field required :rules="[v => !!v || 'Email is required', v => /.+@.+\..+/.test(v) || 'Please enter an email address']" v-model="user.name" light="light" prepend-icon="fa fa-user" label="Email" type="text"></v-text-field>
                  <v-checkbox
                    v-model="checkbox"
                    :rules="checkboxrule"
                    dense
                    >
                    <template v-slot:label class="checkbox-role">
                    <span @click="changeOrder" style="width: 100%">I Agree to Snatch's <span><a @click="openTerms"><u>Terms & Conditions</u></a></span> & <span><a @click="openPrivacyPolicy"><u>Privacy Policy</u></a></span></span>
                    </template>
                    </v-checkbox>
                  <v-btn outlined color="#FFD100" style="background: black" block="block" type="submit" :loading="loading" :disabled="loading" class="mt-2">
                        Register
                        <template v-slot:loader>
                            <span>Loading...</span>
                        </template>
                  </v-btn>                  
                </v-form>
                <v-row>
                      <v-col cols="12" md="12"><span><v-icon x-small>fas fa-backward</v-icon> <a href="#"><u><router-link to="/">Return to Login page</router-link></u></a></span></v-col>
                      <!--
                      <v-col cols="12" md="12" class="text-right"><span><a @click="openTerms"><u>Terms & Conditions</u></a></span> | <span><a @click="openPrivacyPolicy"><u>Privacy Policy</u></a></span></v-col>
                      -->
                  </v-row>   
              </v-card-text>
            </v-card>
          </v-flex>
                </v-fade-transition>
          <v-footer app="app">
      <v-flex class="caption">Copyright By SNATCH PARK BIZSOLUTIONS SDN BHD © 2021</v-flex>
    </v-footer>
        </v-layout>
        <v-dialog
        v-model="dialogLoader"
        persistent
        width="300"
        >
        <v-card
            color="primary"
            dark
        >
            <v-card-text>
            Registering
            <v-progress-linear
                indeterminate
                color="white"
                class="mb-0"
            ></v-progress-linear>
            </v-card-text>
        </v-card>
        </v-dialog>
        <alertbox :dialog="ex.modal" @closed="onClosed" :content="ex.content"></alertbox>
        <v-snackbar
        v-model="toaster"
        :color="toasterColor"
        top
        >
        {{ toastertxt }}
        </v-snackbar>
      </v-container>
</template>

<script>
import timer from '../assets/js/sleeper';
import alertbox from '../components/modals/Notification';

export default {
    name: 'login',

    data(){
        return {
            options: {
                isLoggingIn: '',
                shouldStayLoggedIn: true,
            },

            user: {
                name: '',
                password: ''
            },
            loading: false,
            dialogLoader: false,
            ex: {
                modal: false,
                content: {
                    headline: '',
                    icon: '',
                    chipColor: '',
                    iconColor: '',
                    maintext: '',
                    smalltext: ''
                }
            },
            toaster: false,
            toastertxt: '',
            toasterColor: 'red',
            checkbox: false,
            checkboxrule: []
        }
    },

    components: {
        alertbox
    },

    created(){
        //this.test1();
    },

    methods: {
        async userReg(){
            this.loading = true
            this.dialogLoader = true

            try{
                let response = await this.$store.dispatch("userRegister", {
                                    username: this.user.name,
                                    })

                await timer.sleep(100);
                if (response.data.code === 'AP000')
                {
                    localStorage.setItem('tempitem', 'registered');
                    this.loading = false;
                    this.dialogLoader = false;
                    this.ex.modal = true;
                    this.ex.content.headline = 'Email Registered!';
                    this.ex.content.icon = 'fa fa-check';
                    this.ex.content.chipColor = '#a0e8af';
                    this.ex.content.iconColor = 'green';
                    this.ex.content.maintext = 'Please check your email for verification link.';
                    this.ex.content.smalltext = 'You may now close this screen to return to Login page.';
                }

                else if (response.data.code === 'AP103')
                {
                    this.loading = false;
                    this.dialogLoader = false;
                    this.toaster = true;
                    this.toastertxt = "This email is already registered";
                }

                else
                {
                    this.loading = false;
                    this.dialogLoader = false;
                    this.toaster = true;
                    this.toastertxt = "Something went wrong";
                }
            }

            catch(err){
                this.loading = false;
                this.dialogLoader = false;
                this.toaster = true;
                this.toastertxt = "API Error";
            }
        },

        onClosed(value){
            if (value == false){
                this.autoRefresh = 1;
                this.ex.modal = value;
                this.$router.push({ name: "login" });
            }
        },

        validateBeforeSubmit() {
            this.checkboxrule = [
                v => !!v || 'If you agree with the terms & conditions, please tick the box'
            ];

            //must set this in order to use 'this' as 'self' inside settimeout etc..
            let self = this;

            setTimeout(function () {
                //self.$refs.image.resetValidation();
                //self.$refs.image.reset();

             if (self.$refs.loginForm.validate()) {
                    self.userReg();
                }
            });
        },

        openTerms() {
            window.open("https://www.snatchpark.com/terms-conditions/");
        },

        openPrivacyPolicy() {
            window.open("https://www.snatchpark.com/privacy-policy/");
        },

        changeOrder(e) {
            e.preventDefault();
            e.stopPropagation();
        },
    }
}
</script>

<style scoped lang="scss">
.login-form{
    max-width: 500px !important;
}
</style>